<template>
  <dx-modal
    :value="show"
    @input="close"
    :title="createdKey ? 'Chave de API Criada' : 'Gerar Nova Chave de API'"
    id="modal-api-key-create"
  >
    <template v-if="!createdKey">
      <div class="form-group" :class="{ 'has-error': $v.form.name.$error }">
        <label class="form-label" for="api-key-name">Nome</label>
        <input id="api-key-name" type="text" class="form-input" v-model="form.name"
               placeholder="Ex.: Integração PACS" v-focus>
        <st-form-input-hint :validator="$v.form.name" />
      </div>
      <div class="form-group" :class="{ 'has-error': $v.form.scopes.$error }">
        <label class="form-label">Escopos</label>
        <label class="form-checkbox" v-for="item in scopes" :key="item.key">
          <input type="checkbox" v-model="form.scopes" :value="item.key">
          <i class="form-icon"></i> {{ item.name }}
          <span class="text-gray text-small ml-1">{{ item.description }}</span>
        </label>
        <st-form-input-hint :validator="$v.form.scopes" />
      </div>
      <div class="api-key-notice mt-2">
        <fa-icon :icon="['fal', 'exclamation-triangle']" />
        <span>
          Você poderá visualizar a chave completa <strong>apenas uma vez</strong>,
          logo após a criação.
        </span>
      </div>
    </template>

    <template v-else>
      <div>
        <strong class="mr-2">{{ created.name }}</strong>
        <span
          class="label mr-1"
          :class="scope === 'imaging' ? 'label-info' : 'label-primary'"
          v-for="scope in created.scopes"
          :key="scope"
        >{{ getScopeName(scope) }}</span>
      </div>
      <div class="form-group">
        <label class="form-label text-bold">Sua nova chave de API:</label>
        <div class="input-group">
          <input
            type="text"
            class="form-input key-input"
            :value="createdKey"
            readonly
            ref="keyInput"
          >
          <button
            class="btn btn-primary input-group-btn btn-icon btn-icon-left"
            @click="copyKey"
            :class="{ 'btn-success': copied }"
          >
            <fa-icon :icon="['fal', copied ? 'check' : 'copy']"/>
            {{ copied ? 'Copiado!' : 'Copiar' }}
          </button>
        </div>
      </div>
      <div class="api-key-notice mt-2">
        <fa-icon :icon="['fal', 'exclamation-triangle']" />
        <span>
          <strong>Atenção:</strong> esta é a única vez que você poderá ver esta chave completa.
          Certifique-se de copiá-la agora!
        </span>
      </div>
    </template>

    <template v-slot:footer>
      <button
        class="btn"
        @click="close"
        v-if="createdKey"
      >
        Fechar
      </button>
      <template v-else>
        <button
          class="btn btn-primary mr-1"
          :class="{ loading: creating }"
          @click="create"
          :disabled="creating"
        >
          Gerar Chave
        </button>
        <button class="btn" @click="close">Sair</button>
      </template>
    </template>
  </dx-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { scopes, getName as getScopeName } from '@/data/api-key-scopes';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: this.blankForm(),
      scopes,
      creating: false,
      created: null,
      createdKey: null,
      copied: false,
    };
  },
  validations() {
    return {
      form: {
        name: { required },
        scopes: { required },
      },
    };
  },
  watch: {
    show(newVal) {
      if (!newVal) {
        setTimeout(() => {
          this.form = this.blankForm();
          this.$v.$reset();
          this.created = null;
          this.createdKey = null;
          this.copied = false;
        }, 300);
      }
    },
  },
  methods: {
    getScopeName,
    blankForm() {
      return {
        name: '',
        scopes: [],
      };
    },
    create() {
      this.$v.form.$touch();
      if (this.$v.form.$error) return;

      this.creating = true;

      this.$http.post('/hub/api-keys', this.form)
        .then(({ data }) => {
          this.created = data;
          this.createdKey = data.token;
          this.$toast.success('Chave de API criada com sucesso');
          this.$emit('created', data);
        })
        .catch((error) => {
          this.$toast.error(error);
          this.close();
        })
        .finally(() => {
          this.creating = false;
        });
    },
    copyKey() {
      this.$refs.keyInput.select();
      document.execCommand('copy');
      this.copied = true;

      setTimeout(() => {
        this.copied = false;
      }, 3000);
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "./src/assets/scss/_variables.scss";

  .key-input {
    font-weight: 500;
  }
</style>

<style lang="scss">
  #modal-api-key-create .modal-container {
    max-width: 520px;
  }
</style>
